import { DisabledPrompt, Link } from "@bcm-dev/bcms-vite";
import { WidgetContainer, WidgetView } from "components/shared";
import React from "react";
import "./styles.css";

/**
 * @function OnlineMobileBankingWidget
 * @return {React.Component}
 * @exported true
 * @description Shows the Online and Mobile Banking Agreements
 */

export default function OnlineMobileBankingWidget(props) {
  return(
    <WidgetContainer className="online-mobile-banking-widget">
      <WidgetView text="Online and Mobile Banking Agreements">
        <b>You agreed to the Online and Mobile Banking Terms & Conditions and the eSign Act Disclosure and Consent when you originally registered for Online and Mobile Banking. By logging onto Online or Mobile Banking, you accept and agree to the to the current versions of those terms below.</b>
        <div className="flex-container flex-vertical links-container">
          <DisabledPrompt><Link>eSign Act Disclosure and Consent</Link></DisabledPrompt>
          <DisabledPrompt><Link>Online and Mobile Banking Terms and Conditions</Link></DisabledPrompt>
        </div>
      </WidgetView>
    </WidgetContainer>
  );
}